import React, { useState } from "react";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { isBefore, isAfter, startOfDay, endOfDay } from "date-fns";
import "./datePicker.scss";

//  Handles both UTC to local and local to UTC
const formatDateToLocal = (date, toUTC = false) => {
  if (!date) return "";
  let localDate = new Date(date);
  // Convert to IST (UTC+5:30)
  let istOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
  let istDate = new Date(localDate.getTime() + istOffset);
  if (toUTC) {
    return istDate.toISOString().split("T")[0]; // UTC format YYYY-MM-DD
  } else {
    return istDate.toLocaleDateString("en-CA"); // Local IST format YYYY-MM-DD
  }
};

const DateRangeSelector = ({ onHandleClick }) => {
  //  Local state for temporary selection
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);

  const handleDateChange = (updatedStart, updatedEnd) => {
    if (updatedStart && updatedEnd && updatedStart > updatedEnd) {
      setTempEndDate(null);
      return;
    }
    setTempStartDate(updatedStart);
    setTempEndDate(updatedEnd);
    const startDate = formatDateToLocal(updatedStart);
    const endDate = formatDateToLocal(updatedEnd);
    onHandleClick(startDate, endDate);
  };

  return (
    <div className="date-range-container">
      <DateRangePicker
        appearance="default"
        showOneCalendar
        placeholder="Select Date "
        placement="bottomStart"
        format="dd/MMM/yyyy"
        style={{ width: "100%", borderRadius: 10, height: 36 }}
        onChange={(range) => {
          if (range && range.length === 2) {
            const [start, end] = range;
            handleDateChange(start, end);
          } else {
            handleDateChange(null, null);
          }
        }}
        value={
          tempStartDate && tempEndDate
            ? [new Date(tempStartDate), new Date(tempEndDate)]
            : null
        }
        cleanable
        shouldDisableDate={(date) => {
          const maxStartDate = new Date(2025, 8, 12); // 12 Sep 2025
          const today = endOfDay(new Date());
          return (
            isBefore(date, startOfDay(maxStartDate)) || isAfter(date, today)
          );
        }}
        container={() => document.getElementById("dialog-content")}
        preventOverflow={false}
      />
    </div>
  );
};

export default DateRangeSelector;
